import React, { useRef, useState } from "react";
import { getAPI, getAPIBatch } from "../../helpers/httpHelper";
import ISubContratista from "../../entities/ISubContratista";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import IGerencia from "../../entities/IGerencia";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { Col, Form, Row } from "react-bootstrap";
import {
  API_ADMIN_CONTRATISTA_SUBCONTRATISTA,
  API_ADMIN_GERENCIA,
  API_ADMIN_REQ_NORMATIVOS,
  API_ADMIN_TIPO_DESVIACION,
  API_ADMIN_UNIDAD,
  API_CONTRATO,
  API_VPP,
  ROW_COUNT,
  URL_SUPPORT,
  API_ADMIN_GRAVEDAD_POTENCIAL,
} from "../../helpers/variableHelper";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import IContrato from "../../entities/IContrato";
import { Label, TextField } from "@fluentui/react";
import IRequisitosNormativos from "../../entities/IRequisitosNormativos";
import { ITipoDesviacion } from "../../entities/ITipoDesviacion";
import UserPicker from "../../controls/UserPicker";
import Loading from "../../cross/Loading";
import Select from "react-select";
import { IDesviacion } from "../../entities/IDesviacion";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import DesviacionService from "../../services/DesviacionService";
import { EnumEstadoDesviacion } from "../../entities/helper/EnumEstadoDesviacion";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import IDocumentoDesviacion from "../../entities/IDocumentoDesviacion";
import { currentdate, dateFormatInputReference, shortDate } from "../../helpers/dateHelper";
import { EnumTipoDocumentoAuditoria } from "../../entities/helper/EnumTipoDocumentoAuditoria";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getFileName } from "../../helpers/pathHelper";
import moment from "moment";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import { E_EstadoFormIngresarDesv } from "../../enums/E_EstadoFormulario";
import { E_GravedadPotencial } from "../../enums/E_GravedadPotencial";
import { IGravedadPotencial } from "../../entities/IGravedadPotencial";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import IAuditoria from "../../entities/IAuditoria";
import { cParamsActiveOrderTitle, cParamsActive } from "../../helpers/paramsHelper";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
import { ETipoDesviacion } from "../../enums/E_TipoDesviacion";
const MySwal = withReactContent(Swal);

interface IAgregarDesviacionProps {
  readonly: boolean;
  loading?: boolean;
  itemsDocumentosTest?: IDocumentoDesviacion[];
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbUnidad?: Array<IUnidad>;
  cbContratistaSubconttratista?: Array<ISubContratista>;
  cbContrato?: Array<IContrato>;
  cbRequisitoNormativo?: Array<IRequisitosNormativos>;
  cbPotencial?: Array<IGravedadPotencial>;
  cbTipoDesviacion?: Array<ITipoDesviacion>;
  id?: string;
  is_test?: boolean;
  selectedAudit: IAuditoria | null;
}

const AgregarDesviacion = ({
  readonly,
  loading = true,
  itemsDocumentosTest,
  cbVicepresidencia,
  cbGerenciaSubgerencia,
  cbUnidad,
  cbContratistaSubconttratista,
  cbContrato,
  cbRequisitoNormativo,
  cbPotencial,
  cbTipoDesviacion,
  id,
  is_test,
  selectedAudit,
}: IAgregarDesviacionProps) => {// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 256 como valor de complejidad cognitiva. Esta función realiza varias validaciones del formulario de desviaciones".
  let search = new URLSearchParams(window.location.search);
  const idDesviacion = parseInt(search.get("id") ?? id ?? "0");
  const userInfoToken = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [documentosDesviacion, setDocumentosDesviacion] = useState<IDocumentoDesviacion[]>(itemsDocumentosTest || []);
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboCt, setComboCt] = useState<Array<IContrato>>(cbContrato || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboCSC, setComboCSC] = useState<Array<ISubContratista>>(cbContratistaSubconttratista || []);
  const [comboRN, setComboRN] = useState<Array<IRequisitosNormativos>>(cbRequisitoNormativo || []);
  const [comboTD, setComboTD] = useState<Array<ITipoDesviacion>>(cbTipoDesviacion || []);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>(cbUnidad || []);
  const [comboP, setComboP] = useState<Array<IGravedadPotencial>>(cbPotencial || []);
  const [comboPotencialidadObservacion, setComboPotencialidadObservacion] = useState<Array<IGravedadPotencial>>(cbPotencial || []);
  const [detectadoPor, setDetectadoPor] = useState<IUserPickerValue>();
  const [responsableInvestigacion, setResponsableInvestigacion] = useState<IUserPickerValue>();

  const refInputFile = React.createRef<HTMLInputElement>();
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const [fechaDeteccion, setFechaDeteccion] = useState<string>();

  const [vpp, setVpp] = useState<IComboboxOption | null>(null);
  const [gsg, setGsg] = useState<IComboboxOption | null>(null);
  const [up, setUp] = useState<IComboboxOption | null>(null);
  const [cs, setCs] = useState<IComboboxOption | null>(null);
  const [ct, setCt] = useState<IComboboxOption | null>(null);
  const [asunto, setAsunto] = useState("");
  const [descripcionIncumplimiento, setDescripcion] = useState("");
  const [lenDescripcionInc, setLenDescripcionInc] = useState(0);
  const [lenDescripcionDoc, setLenDescripcionDoc] = useState(0);
  const [rn, setRn] = useState<IComboboxOption | null>(null);
  const [potencialidad, setPotencialidad] = useState<IComboboxOption | null>(null);
  const [tipoDesviacion, setTipoDesviacion] = useState<IComboboxOption | null>(null);

  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [selectedDesviacion, setSelectedDesviacion] = useState<IDesviacion | null>(null);
  const [estadoFormulario, setEstadoFormulario] = useState<E_EstadoFormIngresarDesv>(
    readonly ? E_EstadoFormIngresarDesv.Lectura : E_EstadoFormIngresarDesv.Ingresar
  );
  const totalPageListDocumentos = useRef<number>(0);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Documento"
          onClick={() => {
            DesviacionService.getContenidoArchivo(token, value.URL);
          }}></i>
      </div>
    );
  };

  const componentEliminar = (value: any) => {
    return (
      <div>
        {value.row.original.ID_AUDITORIA == null ? (
          <i
            className="bi bi-trash iconTrash"
            title="Eliminar Documento"
            onClick={() => {
              MySwal.fire({
                html: (
                  <div>
                    <h3>¿Desea eliminar el documento {getFileName(value.row.original.URL)}?</h3>
                  </div>
                ),
                text: "",
                icon: "question",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                showCloseButton: true,
                showCancelButton: true,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await DesviacionService.deleteDocumentoDesviacion(token, value.getValue());

                  await refreshDocuments(value.row.original.ID_DESVIACION, null, selectedDesviacion);
                }
              });
            }}></i>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  };

  usePromiseEffect(async () => {
    await fillCombos();
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    let resultAllTipoDesviacion = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_DESVIACION}/getall`, { Authorization: `Bearer ${token}` }, cParamsActive)
    ).result;
    let sorted = resultAllTipoDesviacion.data
      .filter((tipoDesviacion: ITipoDesviacion) => tipoDesviacion.ID !== ETipoDesviacion.Conformidad)
      .sort((a: any, b: any) => (a.NOMBRE > b.NOMBRE ? 1 : -1));
    setComboTD(sorted);

    if (idDesviacion) {
      let resultDesviacion = await DesviacionService.getDesvicacionByID(token, idDesviacion);
      setSelectedDesviacion(resultDesviacion);

      if (resultDesviacion) {
        await refreshDocuments(resultDesviacion.ID as number, null, resultDesviacion);
        await fillComboGSG(resultDesviacion?.VICEPRESIDENCIA);
        await fillComboUP(resultDesviacion?.GERENCIA_SUBGERENCIA);
        await fillComboUP(resultDesviacion?.GERENCIA_SUBGERENCIA);
        setAsunto(resultDesviacion.ASUNTO);
        setDetectadoPor({
          mail: resultDesviacion?.DETECTADO_POR,
          name: resultDesviacion?.DETECTADO_POR,
        });
        setLenDescripcionInc(
          (resultDesviacion.DESCRIPCION_INCUMPLIMIENTOS !== undefined && resultDesviacion.DESCRIPCION_INCUMPLIMIENTOS.length) || 0
        );
        setResponsableInvestigacion({
          mail: resultDesviacion?.RESPONSABLE_INVESTIGACION,
          name: resultDesviacion?.RESPONSABLE_INVESTIGACION_DISPLAY,
        });
        setVpp({
          label: resultDesviacion.VICEPRESIDENCIA,
          value: resultDesviacion.ID_VICEPRESIDENCIA?.toString(),
        });
        setGsg({
          label: resultDesviacion.GERENCIA_SUBGERENCIA,
          value: resultDesviacion.ID_GERENCIA_SUBGERENCIA?.toString(),
        });
        setUp({
          label: resultDesviacion.UNIDAD_PROYECTO,
          value: resultDesviacion.ID_UNIDAD_PROYECTO?.toString(),
        });
        setFechaDeteccion(moment(resultDesviacion.FECHA_DETECCION).format("yyyy-MM-DD"));
        setDescripcion(resultDesviacion.DESCRIPCION_INCUMPLIMIENTOS);
        setRn({
          label: resultDesviacion.REQUISITO_NORMATIVO,
          value: resultDesviacion.ID_REQUISITO_NORMATIVO?.toString(),
        });
        setPotencialidad({
          label: resultDesviacion.POTENCIALIDAD,
          value: resultDesviacion.ID_POTENCIALIDAD?.toString(),
        });
        setTipoDesviacion({
          label: resultDesviacion.TIPO_DESVIACION,
          value: resultDesviacion.ID_TIPO_DESVIACION?.toString(),
        });
        setCs({
          label: resultDesviacion.CONTRATISTA_SUBCONTRATISTA,
          value: resultDesviacion.ID_CONTRATISTA_SUBCONTRATISTA?.toString(),
        });
        setCt({
          label: resultDesviacion.CONTRATO,
          value: resultDesviacion.ID_CONTRATO?.toString(),
        });
        if (estadoFormulario === E_EstadoFormIngresarDesv.Lectura) {
          setEstadoFormulario(E_EstadoFormIngresarDesv.Lectura);
        } else if (resultDesviacion.ID_ESTADO >= EnumEstadoDesviacion.RegistroAnalisisCausal) {
          setEstadoFormulario(E_EstadoFormIngresarDesv.Lectura);
        } else if (resultDesviacion.ID_AUDITORIA) {
          setEstadoFormulario(E_EstadoFormIngresarDesv.IngresarAuditoría);
        } else {
          setEstadoFormulario(E_EstadoFormIngresarDesv.Ingresar);
        }
      }
    } else {
      setDetectadoPor({ mail: currUser.email, name: currUser.fullname });
    }

    setIsLoading(false);
  }, []);

  const fillCombos = async () => {
    let urls = [
      `${URL_SUPPORT}${API_VPP}/getall`,
      `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`,
      `${URL_SUPPORT}${API_CONTRATO}/getall`,
      `${URL_SUPPORT}${API_ADMIN_GRAVEDAD_POTENCIAL}/getall`,
    ];
    let results = is_test
      ? [
          { data: { data: [{ TITULO: "", ID: 1 }] } },
          { data: { data: [{ TITULO: "", ID: 1 }] } },
          { data: { data: [{ TITULO: "", ID: 1 }] } },
          { data: { data: [{ TITULO: "", ID: 1 }] } },
        ]
      : await getAPIBatch(urls, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle);

    results.forEach((result, index) => {
      switch (index) {
        case 0:
          setComboVcc(result.data.data);
          break;
        case 1:
          setComboCSC(result.data.data);
          break;
        case 2:
          setComboCt(result.data.data);
          break;
        case 3:
          setComboP(result.data.data);
          break;
        case 4:
          break;
      }
    });

    const resultAllRequisitosNormativos = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}/getall`,
        { Authorization: `Bearer ${token}` },
        {
          ...cParamsActiveOrderTitle,
          ORDENADOPOR: "ITEM",
          TEXTO_DISTINC: `DISTINCT ON (rn1."ITEM")`,
        }
      )
    ).result;
    setComboRN(resultAllRequisitosNormativos.data);
  };

  const refreshDocuments = async (idDesviacion?: number, pagination?: IPagination | null, desviacion?: IDesviacion | null) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = is_test
      ? { data: itemsDocumentosTest ?? [], pages: 10 }
      : await DesviacionService.getDocumentosDesviacion(token, {
          ...defaultPagination,
          ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
          ID_DESVIACION: idDesviacion || (selectedDesviacion?.ID as number),
        });
    totalPageListDocumentos.current = result.pages;
    setDocumentosDesviacion(result.data);
  };

  const fillComboGSG = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      VICEPRESIDENCIA: vppId,
    };
    const comboGSG = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboGSG(comboGSG);
  };

  const fillComboUP = async (vppId: string) => {
    let paramsActive = {
      ...cParamsActiveOrderTitle,
      NOMBRE_GERENCIA_SUBGERENCIA: vppId,
    };
    const comboGSG = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboUP(comboGSG);
  };

  const formValidation = (value: Partial<IDesviacion>) => {
    let arrErrors: Array<string> = [];
    if (!value.ID_AUDITORIA) {
      if (!value.ID_VICEPRESIDENCIA) {
        arrErrors.push("ID_VICEPRESIDENCIA");
      }

      if (!value.ID_GERENCIA_SUBGERENCIA) {
        arrErrors.push("ID_GERENCIA_SUBGERENCIA");
      }

      if (!value.ID_UNIDAD_PROYECTO) {
        arrErrors.push("ID_UNIDAD_PROYECTO");
      }

      if (!value.DETECTADO_POR) {
        arrErrors.push("DETECTADO_POR");
      }

      if (!moment(value.FECHA_DETECCION).isValid()) {
        arrErrors.push("FECHA_DETECCION");
      }

      if (!value.DESCRIPCION_INCUMPLIMIENTOS) {
        arrErrors.push("DESCRIPCION_INCUMPLIMIENTO");
      }

      if (!value.ID_REQUISITO_NORMATIVO) {
        arrErrors.push("ID_REQUISITO_NORMATIVO");
      }

      if (!value.ID_POTENCIALIDAD) {
        arrErrors.push("ID_POTENCIALIDAD");
      }

      if (!value.ID_TIPO_DESVIACION) {
        arrErrors.push("ID_TIPO_DESVIACION");
      }
    }

    if (!value.RESPONSABLE_INVESTIGACION) {
      arrErrors.push("RESPONSABLE_INVESTIGACION");
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardarDesviacion = async (enviarDesviacion?: boolean) => {
    let value: Partial<IDesviacion> = {
      ID: selectedDesviacion?.ID,
      ID_UNIDAD_PROYECTO:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_UNIDAD_PROYECTO : parseInt(up?.value || ""),
      ID_GERENCIA_SUBGERENCIA:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_GERENCIA_SUBGERENCIA : parseInt(gsg?.value || ""),
      ID_VICEPRESIDENCIA:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_VICEPRESIDENCIA : parseInt(vpp?.value || ""),
      ID_CONTRATISTA_SUBCONTRATISTA:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría
          ? selectedDesviacion?.ID_CONTRATISTA_SUBCONTRATISTA
          : parseInt(cs?.value || ""),
      ID_CONTRATO: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_CONTRATO : parseInt(ct?.value || ""),
      ID_ESTADO: enviarDesviacion ? EnumEstadoDesviacion.RegistroAnalisisCausal : EnumEstadoDesviacion.EnConstruccion,
      ID_AUDITORIA: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_AUDITORIA : null,
      ID_POTENCIALIDAD:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_POTENCIALIDAD : parseInt(potencialidad?.value || ""),
      ID_TIPO_DESVIACION:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría
          ? selectedDesviacion?.ID_TIPO_DESVIACION
          : parseInt(tipoDesviacion?.value || ""),
      ID_REQUISITO_NORMATIVO:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ID_REQUISITO_NORMATIVO : parseInt(rn?.value || ""),
      RESPONSABLE_INVESTIGACION: responsableInvestigacion?.mail,
      RESPONSABLE_INVESTIGACION_DISPLAY: responsableInvestigacion?.name,
      RESPONSABLE_CIERRE: selectedDesviacion?.RESPONSABLE_CIERRE,
      RESPONSABLE_CIERRE_DISPLAY: selectedDesviacion?.RESPONSABLE_CIERRE_DISPLAY,
      DETECTADO_POR: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.DETECTADO_POR : detectadoPor?.mail,
      DETECTADO_POR_DISPLAY:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.DETECTADO_POR_DISPLAY : detectadoPor?.name,
      FECHA_CREACION: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.FECHA_CREACION : new Date(),
      FECHA_DETECCION:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.FECHA_DETECCION : new Date(fechaDeteccion || ""),
      DESCRIPCION_INCUMPLIMIENTOS:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.DESCRIPCION_INCUMPLIMIENTOS : descripcionIncumplimiento,
      ASUNTO: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.ASUNTO : asunto,
      AUTOR: estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.AUTOR : (currentUser?.email as string),
      AUTOR_DISPLAY:
        estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? selectedDesviacion?.AUTOR_DISPLAY : (currentUser?.fullname as string),
    };

    if (formValidation(value)) {
      if (refInputFile.current?.files) {
        console.log();
      }
      setIsSendingData(true);
      let id = await DesviacionService.ingresoDesviacion(token, value);
      setSelectedDesviacion({
        ...selectedDesviacion,
        ...value,
        ID: id,
        ID_ESTADO: EnumEstadoDesviacion.EnConstruccion,
        CORRELATIVO: `${moment().format("MMYYYY")}-${id}`,
      } as IDesviacion);
      setIsSendingData(false);
      return id;
    } else {
      return -1;
    }
  };

  const handleEnviarDesviacion = async () => {
    let id = await handleGuardarDesviacion(true);
    if (id > -1) {
      setIsSendingData(true);
      await DesviacionService.enviarDesviacion(token, {
        ID: id,
        OBSERVACION: true,
        ENVIAR_NOTIFICACION: true,
      });
      window.location.href = "/desviacion";
    }
  };

  const callback = (id: any, value: Array<IUserPickerValue>) => {
    if (id === "responsableInvestigacion") {
      setResponsableInvestigacion(value?.shift());
    } else if (id === "detectadoPor") {
      setDetectadoPor(value?.shift());
    }
  };
  const validateUploadFile = (value: Partial<IDocumentoDesviacion>) => {
    let arrErrors: Array<string> = [];

    if (!refInputFile.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      try {
        if (documentosDesviacion.filter((d) => d.URL.includes((refInputFile.current?.files as FileList)[0].name)).length > 0) {
          arrErrors.push("ARCHIVO_DUPLICADO");

          MySwal.fire({
            html: (
              <div>
                <h3>Archivo "{(refInputFile.current?.files)[0].name}" ya se encuentra cargado</h3>
              </div>
            ),
            text: "",
            icon: "error",
            showCloseButton: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
    }

    return arrErrors.length === 0;
  };

  const handleGuardarDocumento = async () => {
    let f = (refInputFile.current?.files as FileList)[0] as any;
    let value: Partial<IDocumentoDesviacion> = {
      ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.CargadoInforme,
      ID_DESVIACION: selectedDesviacion?.ID as number,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };
    if (validateUploadFile(value)) {
      (refTxtDescripcionDocumento.current as HTMLTextAreaElement).value = "";
      setLenDescripcionDoc(0);
      setIsUploadingDocs(true);
      let idDesviacion = await handleGuardarDesviacion();
      if (idDesviacion > -1) {
        value.ID_DESVIACION = idDesviacion;
        await DesviacionService.addDocumentosDesviacion(token, value);
        await refreshDocuments(idDesviacion, null, selectedDesviacion);
      }
      setIsUploadingDocs(false);
    }
  };

  const columnHelperDesvDocumentos = createColumnHelper<IDocumentoDesviacion>();
  let columnsDefDesvDocumentos = [
    columnHelperDesvDocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvDocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvDocumentos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDocumentoDesviacion, string>) => componentVer(info.row.original),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperDesvDocumentos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDocumentoDesviacion, number>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: estadoFormulario === E_EstadoFormIngresarDesv.Lectura,
    } as any),
  ] as any;

  return isLoading ? (
    <Loading />
  ) : (
    <div className="rounded bg-white p-2 shadow">
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          callback("", []);
          fillComboUP("");
          fillComboGSG("");
        }}></button>
      <div className="container-fluid mb-4">
        <h1 className="titPrincipal colorTit">Ingreso - Validación</h1>
        <div className="card bg-light border p-3 pt-2 mt-2">
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Correlativo:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {selectedDesviacion?.CORRELATIVO && <span>{selectedDesviacion?.CORRELATIVO}</span>}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Vicepresidencia:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboVcc.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_VICEPRESIDENCIA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setVpp(e || "");
                        fillComboGSG(e.label || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_VICEPRESIDENCIA,
                              label: selectedDesviacion.VICEPRESIDENCIA,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.VICEPRESIDENCIA}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Gerencia/Subgerencia:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboGSG.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_GERENCIA_SUBGERENCIA") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setGsg(e || "");
                        fillComboUP(e.label || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_GERENCIA_SUBGERENCIA,
                              label: selectedDesviacion.GERENCIA_SUBGERENCIA,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.GERENCIA_SUBGERENCIA}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Unidad/Proyecto:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboUP.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_UNIDAD_PROYECTO") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setUp(e || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_UNIDAD_PROYECTO,
                              label: selectedDesviacion.UNIDAD_PROYECTO,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.UNIDAD_PROYECTO}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Contratista/Subcontratista:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboCSC.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setCs(e || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_CONTRATISTA_SUBCONTRATISTA,
                              label: selectedDesviacion.CONTRATISTA_SUBCONTRATISTA,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.CONTRATISTA_SUBCONTRATISTA || "N/A"}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Contrato:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboCt.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setCt(e || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_CONTRATO,
                              label: selectedDesviacion.CONTRATO,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.CONTRATO || "N/A"}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Detectado por:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <UserPicker
                      name={"detectadoPor"}
                      callback={callback}
                      id={"detectadoPor"}
                      key={"1"}
                      multi={false}
                      disabled={false}
                      className={`${arrErrorEmpty.includes("DETECTADO_POR") && "error"} borderColorGris`}
                      defaultValue={detectadoPor}
                    />
                  ) : (
                    <span>{selectedDesviacion?.DETECTADO_POR_DISPLAY}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha de creación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Label>{currentdate()}</Label>
                  ) : (
                    <span>{shortDate(selectedDesviacion?.FECHA_CREACION)}</span>
                  )}
                </Col>
              </div>
            </Col>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Fecha de detección:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Form.Control
                      data-testid="textbox"
                      onChange={(e) => {
                        setFechaDeteccion(e.target.value);
                      }}
                      type="date"
                      defaultValue={
                        selectedDesviacion?.FECHA_DETECCION ? moment(selectedDesviacion?.FECHA_DETECCION).format("yyyy-MM-DD") : fechaDeteccion
                      }
                      className={`${arrErrorEmpty.includes("FECHA_DETECCION") && "error"}`}
                      max={moment().format(dateFormatInputReference)}
                    />
                  ) : (
                    <span>{shortDate(selectedDesviacion?.FECHA_DETECCION)}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Asunto:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <TextField
                      data-testid="textbox2"
                      className="borderGris"
                      defaultValue={selectedDesviacion?.ASUNTO}
                      onChange={(e) => {
                        setAsunto((e as React.ChangeEvent<HTMLInputElement>).target.value);
                      }}></TextField>
                  ) : (
                    <span>{selectedDesviacion?.ASUNTO}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Descripción de incumplimientos:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <div>
                      <TextField
                        data-testid="textbox3"
                        multiline
                        className={`${arrErrorEmpty.includes("DESCRIPCION_INCUMPLIMIENTO") && "error"} borderGris`}
                        onChange={(e) => {
                          setLenDescripcionInc((e as React.ChangeEvent<HTMLTextAreaElement>).target.value.length);
                          setDescripcion((e as React.ChangeEvent<HTMLTextAreaElement>).target.value);
                        }}
                        defaultValue={selectedDesviacion?.DESCRIPCION_INCUMPLIMIENTOS}
                        maxLength={1000}></TextField>
                      <span>{lenDescripcionInc}/1000</span>
                    </div>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          selectedDesviacion?.DESCRIPCION_INCUMPLIMIENTOS?.replace("Problema:", "<strong>Problema:</strong><br/>")?.replace(
                            "Evidencia:",
                            "<br/><strong>Evidencia:</strong><br/>"
                          ) || "",
                      }}></span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Requisito normativo:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboRN.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_REQUISITO_NORMATIVO") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setRn(e || "");
                      }}
                      defaultValue={
                        selectedDesviacion
                          ? {
                              value: selectedDesviacion.ID_REQUISITO_NORMATIVO,
                              label: selectedDesviacion.REQUISITO_NORMATIVO,
                            }
                          : []
                      }
                    />
                  ) : (
                    <span>{selectedDesviacion?.REQUISITO_NORMATIVO}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Tipo de desviación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar ? (
                    <Select
                      options={
                        comboTD.map((vcc) => ({
                          value: vcc.ID,
                          label: vcc.NOMBRE,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_TIPO_DESVIACION") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setTipoDesviacion(e || "");
                        if (e.value === ETipoDesviacion.NoConformidad) {
                          setPotencialidad({
                            label: "Alta",
                            value: E_GravedadPotencial.Alta.toString(),
                          });
                        } else if (e.value === ETipoDesviacion.OportunidadMejora) {
                          setPotencialidad({
                            label: "Baja",
                            value: E_GravedadPotencial.Baja.toString(),
                          });
                        } else {
                          setPotencialidad(null);
                        }
                        if (e.value === ETipoDesviacion.Observacion) {
                          let filtroPotencialidadObservacion = comboP.filter((potencialidad) => potencialidad.ID !== E_GravedadPotencial.Alta);
                          setComboPotencialidadObservacion(filtroPotencialidadObservacion);
                        }
                      }}
                      defaultValue={tipoDesviacion}
                    />
                  ) : (
                    <span>{selectedDesviacion?.TIPO_DESVIACION}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">{estadoFormulario === E_EstadoFormIngresarDesv.Ingresar && <strong>(*)</strong>}</span>
                  <label>Potencialidad:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar &&
                  tipoDesviacion?.value.toString() !== ETipoDesviacion.Observacion.toString() ? (
                    <Select
                      options={
                        comboP.map((potencialidad) => ({
                          value: potencialidad.ID,
                          label: potencialidad.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_POTENCIALIDAD") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setPotencialidad(e || "");
                      }}
                      value={potencialidad}
                      isDisabled={
                        potencialidad?.value === E_GravedadPotencial.Alta.toString() ||
                        potencialidad?.value.toString() === E_GravedadPotencial.Baja.toString()
                          ? true
                          : false
                      }
                    />
                  ) : estadoFormulario === E_EstadoFormIngresarDesv.Ingresar &&
                    tipoDesviacion?.value.toString() === ETipoDesviacion.Observacion.toString() ? (
                    <Select
                      options={
                        comboPotencialidadObservacion.map((potencialidad) => ({
                          value: potencialidad.ID,
                          label: potencialidad.TITULO,
                        })) as any
                      }
                      className={`${arrErrorEmpty.includes("ID_POTENCIALIDAD") && "error"}`}
                      placeholder="Seleccione"
                      isClearable={true}
                      onChange={(e: any) => {
                        setPotencialidad(e || "");
                      }}
                      value={potencialidad}
                    />
                  ) : (
                    <span>{selectedDesviacion?.POTENCIALIDAD}</span>
                  )}
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <span className="text-danger">
                    {(estadoFormulario === E_EstadoFormIngresarDesv.Ingresar || estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría) && (
                      <strong>(*)</strong>
                    )}
                  </span>
                  <label>Responsable de investigación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar || estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría ? (
                    <UserPicker
                      name={"responsableInvestigacion"}
                      callback={callback}
                      id={"responsableInvestigacion"}
                      key={"1"}
                      multi={false}
                      disabled={false}
                      className={`${arrErrorEmpty.includes("RESPONSABLE_INVESTIGACION") && "error"} borderColorGris`}
                      defaultValue={responsableInvestigacion}
                    />
                  ) : (
                    <span>{selectedDesviacion?.RESPONSABLE_INVESTIGACION_DISPLAY}</span>
                  )}
                </Col>
              </div>
              {selectedDesviacion?.ID_AUDITORIA ? (
                <span>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Responsable de Cierre de Desviación:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{selectedDesviacion?.RESPONSABLE_CIERRE_DISPLAY}</span>
                    </Col>
                  </div>
                  <div className="row mb-2 ajusteInput">
                    <Col xs="12" md="6" lg="4">
                      <label>Auditores Participantes:</label>
                    </Col>
                    <Col xs="12" md="6" lg="8">
                      <span>{selectedAudit?.AUDITORES_ACOMPANANTES_DISPLAY}</span>
                    </Col>
                  </div>
                </span>
              ) : (
                <React.Fragment />
              )}
            </Col>
          </Row>

          <div className="row mb-2 ajusteInput">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
              <h5 className="titPaneles">
                {estadoFormulario === E_EstadoFormIngresarDesv.Ingresar || estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría
                  ? "Adjuntar evidencias"
                  : "Evidencias"}
              </h5>
            </div>
            {(estadoFormulario === E_EstadoFormIngresarDesv.Ingresar || estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría) && (
              <div className="row border m-1 p-1 rounded">
                <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                  <label>Descripción</label>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                  <textarea
                    data-testid="textbox4"
                    className="form-control form-control-sm"
                    rows={3}
                    ref={refTxtDescripcionDocumento}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLenDescripcionDoc(e.target.value.length)}
                    maxLength={250}></textarea>
                  <span>{lenDescripcionDoc}/250</span>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                  <label>Adjuntar </label>
                  <span className="text-danger">
                    <small> Peso maximo (50 mb).</small>
                  </span>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                  {isUploadingDocs ? (
                    <Loading />
                  ) : (
                    <div className="input-group">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="inputGroupFile04"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Seleccionar Archivos"
                        ref={refInputFile}
                      />
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        id="inputGroupFileAddon04"
                        onClick={() => {
                          handleGuardarDocumento();
                        }}
                        disabled={isUploadingDocs}>
                        Subir
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {((selectedDesviacion?.ID_ESTADO as number) >= EnumEstadoDesviacion.EnConstruccion || selectedDesviacion === null) && (
            <div className="row mb-2 ajusteInput">
              <AdminListaPagination
                defaultSortBy="ID"
                sortDirection="DESC"
                totalPages={totalPageListDocumentos}
                resultPerPage={ROW_COUNT}
                callback={(pagination) => {
                  refreshDocuments(idDesviacion || (selectedDesviacion?.ID as number), pagination, selectedDesviacion);
                }}
                data={documentosDesviacion}
                reload={() => {
                  refreshDocuments(idDesviacion || (selectedDesviacion?.ID as number), null, selectedDesviacion);
                }}
                columnsDef={columnsDefDesvDocumentos}
                hideAdd={true}
                hideExport={true}
              />
            </div>
          )}

          {isSendingData ? (
            <Loading />
          ) : (
            <div className="row mb-2 ajusteInput mt-4">
              <Col xs="12" md="12" lg="12" className="text-center">
                {(estadoFormulario === E_EstadoFormIngresarDesv.Ingresar || estadoFormulario === E_EstadoFormIngresarDesv.IngresarAuditoría) && (
                  <span>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarDesviacion();
                      }}
                      disabled={isSendingData}>
                      Guardar
                    </button>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleEnviarDesviacion();
                      }}
                      disabled={isSendingData}>
                      Enviar
                    </button>
                  </span>
                )}
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/desviacion";
                  }}
                  disabled={isSendingData}>
                  Volver
                </button>
              </Col>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgregarDesviacion;
